<template>
    <div>
        <modal-new-formation></modal-new-formation>

        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement de la formation
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header" v-if="formation_id!=0">
                <h1>
                    {{getFormation.titre}}
                    <small> # {{getFormation.inscriptions.length}} inscrits</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Formations/examens</a></li>
                    <li class="active"><a href="#">#{{getFormation.titre}}</a></li>
                </ol>
            </section>

            <section class="content-header" v-if="formation_id==0">
                <h1>
                    Formations/examens
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Formations/examens</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="{ 'active': formation_id!=0 }" v-if="formation_id!=0">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Fiche de la formation/examen</a>
                                </li>

                                <li :class="" v-if="formation_id!=0">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Inscriptions et résultats</a>
                                </li>

                                <li :class="" v-if="formation_id!=0">
                                    <a href="#member_tab_facturation"
                                       aria-controls="#member_tab_facturation"
                                       data-toggle="tab"
                                       aria-expanded="false">Facturation</a>
                                </li>

                                <li :class="{ 'active': formation_id==0 }">
                                    <a href="#member_tab_3"
                                       aria-controls="#member_tab_3"
                                       data-toggle="tab"
                                       aria-expanded="false">Listing des formations/examens</a>
                                </li>

                                <li class="pull-right">
                                    <a @click.prevent="showModalNewFormation()">Ajouter une formation/un examen</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div v-if="formation_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': formation_id!=0 }" id="member_tab_1">
                        <MainFormFormation
                                v-if="formation_id!=0"
                                :loadingTableMembres="loading"
                                @onNeedRefreshFormation="refreshFormation()"
                        ></MainFormFormation>
                    </div>
                    <div v-if="formation_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                          id="member_tab_2">
                        <InscriptionsResultats
                                v-if="formation_id!=0"
                        ></InscriptionsResultats>
                    </div>

                    <div v-if="formation_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         id="member_tab_facturation">
                        <FacturationFormation
                                v-if="formation_id!=0"
                                :formation="getFormation"
                        ></FacturationFormation>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': formation_id==0 }" id="member_tab_3">
                        <ListingFormation>
                        </ListingFormation>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MainFormFormation from './MainFormFormation.vue'
    import FacturationFormation from './FacturationFormation.vue'
    import ModalNewFormation from './ModalNewFormation'
    import ListingFormation from './ListingFormation'
    import InscriptionsResultats from "./InscriptionsResultats";

    export default {
        data() {
            return {
                loading: false,
                formation_id: null
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getFormation: 'getFormation',
                getTypesFormation: 'getTypesFormation',
                getRoute: 'getRoute',
            })
        },
        methods: {
            ...mapActions({
                setFormation: 'setFormation',
                setTypesFormation: 'setTypesFormation',
                setListeFormation: 'setListeFormation',
            }),
            showModalNewFormation: function () {
                $('#modalNewFormation').modal()
            },
            refreshFormation: function () {
                return this.loadFormation();
            },
            loadingComplete: function () {
                return this.formation_id == 0 ? true :
                    (this.getFormation != null && this.getTypesFormation != null)
            },
            loadTypesFormations: function () {
                this.$http.get(this.getRoute('getAllTypesFormation')).then((response) => {
                    this.setTypesFormation(response.body)
                }, (response) => {
                });
            },
            loadListeFormations: function () {
                this.$http.get(this.getRoute('getAllFormations')).then((response) => {
                    this.setListeFormation(response.body)
                }, (response) => {
                });
            },
            loadFormation: function () {
                this.loading = true
                if (this.formation_id == 0)
                    return;
                this.$http.get(this.getRoute('Secretariat.getInfosFormation') + this.formation_id)
                    .then((response) => {
                        this.setFormation(response.body)
                        this.loading = false
                    }, (response) => {
                        this.loading = false
                        this.setFormation(null)
                    });
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.formation_id = to.params.formation_id;
            // console.log("Update to " + this.formation_id)
            this.setFormation(null)
            this.loadTypesFormations()
            this.loadListeFormations()
            this.loadFormation()
            next()

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.formation_id = vm.$route.params.formation_id
                vm.setFormation(null)
                vm.loadTypesFormations()
                vm.loadListeFormations()
                vm.loadFormation()
            })
        },
        watch: {},
        components: {
            InscriptionsResultats,
            FacturationFormation,
            MainFormFormation,
            ModalNewFormation,
            ListingFormation,
            InscriptionsResultats,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Formation/AppFormation.vue